// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "保险心理实务",
      "tec": "吕迎春",
      "week": "1-6周",
      "add": "教学楼D座325经管"
    },
    {
      "sub": "保险企业经营与管理",
      "tec": "薛睿",
      "week": "1-7周",
      "add": "教学楼D座325经管"
    },
    0,
    0,
    0
  ],
  "2": [
    {
      "sub": "经济法",
      "tec": "马喆",
      "week": "1-6周",
      "add": "教学楼D座328经管"
    },
    {
      "sub": "机动车辆保险",
      "tec": "杨屏",
      "week": "1-6周",
      "add": "教学楼D座228经管"
    },
    {
      "sub": "保险企业经营与管理",
      "tec": "薛睿",
      "week": "1-7周",
      "add": "教学楼D座225经管"
    },
    0,
    0
  ],
  "3": [
    {
      "sub": "保险心理实务",
      "tec": "吕迎春",
      "week": "1-6周",
      "add": "教学楼D座324经管"
    },
    [
      {
        "sub": "保险企业经营与管理",
        "tec": "薛睿",
        "week": "1-3周",
        "add": "教学楼D座325经管"
      },
      {
        "sub": "经济法",
        "tec": "马喆",
        "week": "4-6周",
        "add": "教学楼D座327经管"
      }
    ],
    0,
    0,
    0
  ],
  "4": [
    0,
    {
      "sub": "经济法",
      "tec": "马喆",
      "week": "1-6周",
      "add": "教学楼D座328经管"
    },
    {
      "sub": "学术论文写作",
      "tec": "薛睿",
      "week": "1-4周",
      "add": "教学楼D座224经管"
    },
    0,
    0
  ],
  "5": [
    {
      "sub": "机动车辆保险",
      "tec": "杨屏",
      "week": "1-6周",
      "add": "教学楼D座314文法"
    },
    {
      "sub": "保险企业经营与管理",
      "tec": "薛睿",
      "week": "1-7周",
      "add": "教学楼D座325经管"
    },
    0,
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
